export const namespaced = true;

export const state = {
  current: {},
  olympic: null,
};

export const mutations = {
  SET_COURSE(state, payload) {
    state.current = payload;
  },
  SET_OLYMPIC(state, payload) {
    state.olympic = payload;
  },
  CLEAR(state) {
    state.current = {};
    state.olympic = null;
  },
};

export const actions = {
  setCourse({ commit }, payload) {
    commit("SET_COURSE", payload);
  },
  setOlympic({ commit }, payload) {
    commit("SET_OLYMPIC", payload);
  },
  clear({ commit }) {
    commit("CLEAR");
  },
};
